import { render, staticRenderFns } from "./OwnerOccupancyCreditCalculator.vue?vue&type=template&id=51a21ebc&lang=pug"
import script from "./OwnerOccupancyCreditCalculator.vue?vue&type=script&lang=ts"
export * from "./OwnerOccupancyCreditCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports